import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconChevronRight } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { forwardRef } from 'react';
import { ActionLink, LabelXSmallBold } from '../../../primitives/index.js';
import { HEADER_QA_ID, qaId } from '../../../utils/qaId.js';
export const Hotline = forwardRef(({
  children,
  openingHours,
  ...restProps
}, ref) => {
  const {
    t
  } = useTranslation();
  return _jsxs(ActionLink, {
    ...restProps,
    ref: ref,
    children: [t('header:hotline.title'), ":", _jsx(LabelXSmallBold, {
      "data-cy": qaId(HEADER_QA_ID, 'hotline'),
      "data-testid": qaId(HEADER_QA_ID, 'hotline'),
      color: "contentInversePrimary",
      children: children
    }), t('header:hotline.text.short', {
      openingHours
    }), _jsx(IconChevronRight, {})]
  });
});